import { NativeModules } from 'react-native';
import { GetAppsResponse } from './getApps';

const getAppDetails = async (
  package_name: string
): Promise<GetAppsResponse | { error: string }> => {
  try {
    const app = await NativeModules.AppDetailsModule.getAppDetails(
      package_name
    );

    return app;
  } catch (e) {
    console.log('Error getting app details: ', e);
    return { error: 'could not get app details' };
  }
};

export default getAppDetails;
